'use strict';

export default {
  setEmailModel(state, obj) {
    state.emailModel = obj;
  },
  setEmailSender(state, obj) {
    state.emailSender = obj;
  },
  setEmailBalance(state, obj) {
    state.emailBalance = obj;
  },
  setEmailReport(state, obj) {
    obj.realTotal=obj.total;
    if(state.emailReport.statistics && !obj.refresh){
      obj.statistics=state.emailReport.statistics;
      obj.total=state.emailReport.total;
    }
    state.emailReport = obj;
  }
};



// WEBPACK FOOTER //
// ./src/store/modules/email/mutations.js